import { SvgIcon, SvgIconProps } from '@mui/material'

const ResetIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 32 32" fill="none" {...props}>
      <rect width="32" height="32" rx="8" fill="#FF3030"></rect>
      <path
        d="M10.687 21.799H13.3422C13.4454 21.8012 13.5469 21.7714 13.6323 21.7142C13.6778 21.6837 13.7187 21.6455 13.7528 21.6002C13.8037 21.5328 13.838 21.4522 13.8494 21.3644C13.8529 21.3381 13.8542 21.3117 13.8535 21.2855V19.0388C13.8535 18.7626 13.6297 18.5388 13.3535 18.5388C13.0774 18.5388 12.8535 18.7626 12.8535 19.0388V20.4226C11.439 19.4344 10.5203 17.8234 10.5203 15.9686C10.5203 13.8098 11.7639 11.9406 13.5761 11.04C13.8234 10.9171 13.9242 10.617 13.8014 10.3697C13.6785 10.1225 13.3784 10.0216 13.1311 10.1445C10.992 11.2075 9.52026 13.4157 9.52026 15.9686C9.52026 17.91 10.3709 19.6225 11.7149 20.799H10.687C10.4109 20.799 10.187 21.0228 10.187 21.299C10.187 21.5751 10.4109 21.799 10.687 21.799Z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2384 21.6301C18.1155 21.3828 18.2163 21.0827 18.4636 20.9598C20.2758 20.0593 21.5195 18.1901 21.5195 16.0313C21.5195 13.8769 20.2799 12.0513 18.4636 11.1487C18.2163 11.0258 18.1155 10.7257 18.2384 10.4784C18.3613 10.2311 18.6614 10.1303 18.9087 10.2531C21.0437 11.3142 22.5195 13.4741 22.5195 16.0313C22.5195 18.5842 21.0477 20.7923 18.9087 21.8554C18.6614 21.9783 18.3613 21.8774 18.2384 21.6301Z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1861 10.7009C18.1861 10.4248 18.41 10.2009 18.6861 10.2009H21.3528C21.629 10.2009 21.8528 10.4248 21.8528 10.7009C21.8528 10.977 21.629 11.2009 21.3528 11.2009H18.6861C18.41 11.2009 18.1861 10.977 18.1861 10.7009Z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6861 13.461C18.41 13.461 18.1861 13.2371 18.1861 12.961V10.7009C18.1861 10.4248 18.41 10.2009 18.6861 10.2009C18.9623 10.2009 19.1861 10.4248 19.1861 10.7009V12.961C19.1861 13.2371 18.9623 13.461 18.6861 13.461Z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5001 12C16.5001 11.7239 16.2763 11.5 16.0001 11.5C15.724 11.5 15.5001 11.7239 15.5001 12V17.3333C15.5001 17.6095 15.724 17.8333 16.0001 17.8333C16.2763 17.8333 16.5001 17.6095 16.5001 17.3333V12ZM16.8334 19.5001C16.8334 19.9603 16.4603 20.3334 16.0001 20.3334C15.5398 20.3334 15.1667 19.9603 15.1667 19.5001C15.1667 19.0398 15.5398 18.6667 16.0001 18.6667C16.4603 18.6667 16.8334 19.0398 16.8334 19.5001Z"
        fill="white"
      ></path>
    </SvgIcon>
  )
}

export default ResetIcon
